import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {action, makeAutoObservable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {IPredictionsStore} from "data/stores/predictions/predictions.store";

export interface IPredictionsShareModalController extends ViewController {
	get predictionSharingImgUrl(): string | null;

	fetchSharingImg: () => void;
}

@injectable()
export class PredictionsShareModalController implements IPredictionsShareModalController {
	constructor(@inject(Bindings.PredictionsStore) private _predictionsStore: IPredictionsStore) {
		makeAutoObservable(this);
	}

	get predictionSharingImgUrl(): string | null {
		return this._predictionsStore.imagePathForSharing;
	}

	dispose(): void {
		return;
	}

	init(): void {
		return;
	}

	@action fetchSharingImg = () => {
		void this._predictionsStore.fetchSharingUrl();
	};
}
